// Provides connection to fastapi application
//
import axios from "axios";

export default axios.create({
	baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8000",
	// timeout: 0,
	// headers: {'X-Custom-Header': 'foobar'}
});
